var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNetworkBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C17.8513 0 23 5.14872 23 11.5C23 17.8513 17.8513 23 11.5 23C5.14872 23 0 17.8513 0 11.5C0 5.14872 5.14872 0 11.5 0Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5248 10.2654L10.2661 8.52984L10.6331 8.16279L11.5033 7.29262L14.4665 10.2654L16.1915 8.52984L11.5033 3.83398L6.7998 8.52984L8.5248 10.2654Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5053 13.2301L13.2373 11.498L11.5053 9.76599L9.7732 11.498L11.5053 13.2301Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4665 12.7383L11.5023 15.7024L10.4616 14.6617L10.2699 14.47L8.5248 12.7383L6.7998 14.4633L11.5033 19.1591L16.1915 14.4633L14.4665 12.7383Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5658 13.234L7.29785 11.502L5.56582 9.76992L3.83377 11.502L5.5658 13.234Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4359 13.234L19.168 11.502L17.4359 9.7699L15.7039 11.502L17.4359 13.234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkBnb);
export default __webpack_public_path__ + "static/media/icon-network-bnb.0a6331fb2eb22471c27fa8f5f4c5e5d2.svg";
export { ForwardRef as ReactComponent };